export default __webpack_public_path__ + "static/media/wlm.d20d4a5a.svg";